// https://redux.js.org/usage/usage-with-typescript#type-checking-middleware
// @ts-nocheck
import { Middleware } from '@reduxjs/toolkit';
import { fetchAuthSession } from '../auth';

const initializeStore: Middleware = (storeAPI) => (next) => async (action) => {
  if (action.type === 'INITIALIZE_STORE') {
    try {
      await storeAPI.dispatch(fetchAuthSession()).unwrap();
    } catch {
      // swallow auth session errors during store initialization
    }
  }
  return next(action);
};

export { initializeStore };
